import type { TabConfig } from '../common/types';
import type { OnboardingTabId } from './types';

export const ONBOARDING_QUESTIONNAIRE_BASE_PATH = '/questionnaires/onboarding';
export const ONBOARDING_QUESTIONNAIRE_ROUTE_PATH = `${ONBOARDING_QUESTIONNAIRE_BASE_PATH}/:onboardingQuestionnaireId/*`;

export const ONBOARDING_TAB_IDS = {
  INTRODUCTION: 'introduction',
  GENERAL: 'general',
  PRIMARY_INSURANCE: 'primary-insurance',
  SECONDARY_INSURANCE: 'secondary-insurance',
  REFERRAL: 'referral',
  AGREEMENT: 'agreement',
  SUBMIT: 'submit',
} as const;

export const ONBOARDING_TAB_CONFIGS: ReadonlyArray<TabConfig<OnboardingTabId>> = [
  {
    id: ONBOARDING_TAB_IDS.INTRODUCTION,
    label: 'Introduction',
    path: ONBOARDING_TAB_IDS.INTRODUCTION,
  },
  { id: ONBOARDING_TAB_IDS.GENERAL, label: 'General', path: ONBOARDING_TAB_IDS.GENERAL },
  {
    id: ONBOARDING_TAB_IDS.PRIMARY_INSURANCE,
    label: 'Primary Ins.',
    path: ONBOARDING_TAB_IDS.PRIMARY_INSURANCE,
  },
  {
    id: ONBOARDING_TAB_IDS.SECONDARY_INSURANCE,
    label: 'Secondary Ins.',
    path: ONBOARDING_TAB_IDS.SECONDARY_INSURANCE,
  },
  { id: ONBOARDING_TAB_IDS.REFERRAL, label: 'Referral', path: ONBOARDING_TAB_IDS.REFERRAL },
  { id: ONBOARDING_TAB_IDS.AGREEMENT, label: 'Agreement', path: ONBOARDING_TAB_IDS.AGREEMENT },
  { id: ONBOARDING_TAB_IDS.SUBMIT, label: 'Submit', path: ONBOARDING_TAB_IDS.SUBMIT },
];

export const DOCUMENT_SUBMISSION_METHODS = {
  UPLOADED: 'Uploaded',
  CAPTURED: 'Captured',
} as const;

export const DOCUMENT_TYPES = {
  INSURANCE_CARD: 'INSURANCE_CARD',
  REFERRAL_REPORT: 'REFERRAL_REPORT',
} as const;
